import { c as _c } from "react/compiler-runtime";
import { useAreSceneLicensesAvailable } from "@hooks/subscription/use-are-scene-licenses-available";
import { activeMemberKeysSelector } from "@store/active-members/active-members-selector";
import { activeSeatUsageSelector, hasUserRoleConstraintSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
/**
 * Returns what it takes to tell which seats the members of the selected workspace hold, see
 * getHeldSeats. Which Sphere XG seats count depends on the constraints of the workspace plan.
 */
export function useMemberSeatsLookup() {
  const $ = _c(5);
  const activeMemberKeys = useAppSelector(activeMemberKeysSelector);
  const isActiveSeatPlan = useAppSelector(activeSeatUsageSelector) !== null;
  const isUserRolePlan = useAppSelector(hasUserRoleConstraintSelector);
  const hasSceneSeats = useAreSceneLicensesAvailable();
  let t0;
  if ($[0] !== activeMemberKeys || $[1] !== hasSceneSeats || $[2] !== isActiveSeatPlan || $[3] !== isUserRolePlan) {
    t0 = {
      activeMemberKeys,
      isActiveSeatPlan,
      isUserRolePlan,
      hasSceneSeats
    };
    $[0] = activeMemberKeys;
    $[1] = hasSceneSeats;
    $[2] = isActiveSeatPlan;
    $[3] = isUserRolePlan;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}